import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, Typography, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'react-admin';
import SelectBox from '../info-page/select-box';
import icSearch from '../../assets/icons/grayscale-3-search.png'

const useStyles = makeStyles({
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    textSearch: {
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
});

const FilterInput = ({ onChangeValue, value, placeholder, open }) => {
    const classes = useStyles();
    return (

        <Box width={200} display='flex' style={{ borderRadius: '8.1px', border: ' solid 0.8px #f1f2f4', backgroundColor: "#f7f7f7" }} >
            < img src={icSearch} className={classes.iconSearch} width={15} height={15} style={{ margin: 'auto 2px auto 5px' }}></img>
            <InputBase
                autoFocus={open === true ? true : false}
                value={value}
                onChange={onChangeValue}
                placeholder={placeholder}
                inputProps={{
                    'aria-label': 'search',
                    className: classes.textSearch,
                }}
                style={{ width: '180px' }}
            />
        </Box>
    )
}

function SelectBoxFilter({ label, data, disabled, value, onChange, keyName, placeholder, bgcolor, isRequired }) {
    const translate = useTranslate();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState('');

    const handleClickOpen = () => {
        setOpen(!open)
    }

    const onChangeValue = (value) => {
        onChange(value);
        setOpen(false);
    }

    const onChangeFilter = (e) => {
        setFilter(e.target.value)
    }

    return (
        <SelectBox
            required={isRequired}
            disabled={disabled}
            label={label}
            value={value}
            open={open}
            handleClick={handleClickOpen}
            bgcolor={bgcolor}
            filter={(
                <Box style={{ backgroundColor: "#ffffff" }} p={1} className={classes.boxBoder}>
                    <FilterInput onChangeValue={onChangeFilter} value={filter} placeholder={placeholder} open={open} />
                </Box>
            )}
        >
            {
                data.filter(item => item[keyName].toUpperCase().includes(filter.toUpperCase())).length !== 0 ?
                    (
                        data.filter(item => item[keyName].toUpperCase().includes(filter.toUpperCase())).map(row => (
                            <Box className={classes.boxBoder} key={row.id.toString()}>
                                <ListItem style={{ padding: '8px' }} button onClick={() => onChangeValue(row)}>
                                    <Typography className={classes.TexTSelect} >{row[keyName]}</Typography>
                                </ListItem>
                            </Box>
                        ))
                    )
                    :
                    (
                        <Box display='flex' width='100%' justifyContent='center' my={1}>
                            <Typography className={classes.TexTSelect} >{translate(`pos.dashboard.notfound`)}</Typography>
                        </Box>
                    )
            }
        </SelectBox>
    )
}

SelectBoxFilter.propTypes = {
    label: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    keyName: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    bgcolor: PropTypes.string,
}

export default SelectBoxFilter;
